// Generated  Wed 14 Aug 2024 13:04:10 CEST
import { MailLogo } from './components/logos/MailLogo';
import { LocationLogo } from './components/logos/LocationLogo';
import { PVLogo } from './components/logos/PVLogo';
import { AnnualConsLogo } from './components/logos/AnnualConsLogo';
import { EnergyProfLogo } from './components/logos/EnergyProfLogo';
import { HeatSupplyLogo } from './components/logos/HeatSupplyLogo';
import { BuildingLogo } from './components/logos/BuildingLogo';
import { ChargingStatLogo } from './components/logos/ChargingStatLogo';
import { EnergyLogo } from './components/logos/EnergyLogo';
import { ReportLogo } from './components/ReportLogo';

export default [
  //{
  //  page: 'adrress_pre_collection',
  //  model: 'address_information',
  //  title: 'Email',
  //  icon: <MailLogo />,
  //  name: 'email',
  //  type: 'email',
  //  is_required: true,
  //   category: 'Wohin dürfen wir Ihre Ergebnisse senden?',
  //   label: 'Email',
  //   description: 'Zu dieser Adresse senden wir Ihnen die Ergebnisse Ihrer Analyse.',
  // },

  // {
  //     "page": "Standort & Gebäude",
  //     "model": "building_information",
  //     "name": "building_information",
  //     "type": "custom",
  //     "is_required": true,
  // },
  {
    page: 'Adresse',
    model: 'address_information',
    title: 'Adresse',
    icon: <LocationLogo fill="var(--sidebar-icon-color)" />,
    name: 'location_information',
    type: 'custom',
    is_required: true,
    category: 'Adresse',
  },
   {
    page: 'Adresse',
    title: 'Adresse',
    model: 'meta_information',
    icon: <MailLogo fill="var(--sidebar-icon-color)" />,
    name: 'dsgvo',
    type: 'checkbox',
    is_required: true,
    label:
      "<span style='font-size: 14px; margin-bottom: 0;margin-top: 0;'>Ich willige in die Verarbeitung meiner Daten zum Zweck der Erstellung eines Exposés sowie zur Optimierung und Weiterentwicklung der Software ein. Details finden Sie unter: <a target='_blank' style='color:#8F94FF' href='https://www.gridty.com/datenschutz'>gridty.com/datenschutz.</a>",
    description:
      'Unsere Datenschutzbestimmungen finden Sie auf https://www.gridty.com/datenschutz. Alle Daten werden von uns immer verschlüsselt übertragen und ausschliesslich auf Servern in Deutschland gespeichert.',
  },
  {
    page: 'PV-Fläche',
    model: 'pv_area',
    title: 'PV-Fläche',
    icon: <PVLogo fill="var(--sidebar-icon-color)" />,
    name: 'pv_area',
    type: 'custom',
    is_required: true,
    category: 'PV-Fläche',
  },
  {
    page: 'total_consumption_el',
    title: 'Stromverbrauch',
    icon: <AnnualConsLogo fill="var(--sidebar-icon-color)" />,
    model: 'electricity_information',
    name: 'total_consumption_el',
    type: 'integer',
    is_required: true,
    placeholder: '1-50000000',
    unit: 'kWh',
    category: 'Jährlicher Verbrauch',
    label: 'Wie hoch ist Ihr jährlicher Strombedarf',
    description: 'Ihr jährlicher Gesamtenergieverbrauch an Elektrizität in kWh.',
    min: 1.0,
    max: 50000000.0,
    min_err: 'Dieser Wert is leider zu niedrig.',
    max_err: 'Sind Sie sicher? Dieser Wert ist sehr hoch.',
  },
  {
    page: 'total_consumption_el',
    title: 'Stromverbrauch',
    icon: <AnnualConsLogo fill="var(--sidebar-icon-color)" />,
    model: 'electricity_information',
    name: 'av_price_el',
    type: 'float',
    is_required: true,
    placeholder: '1-100',
    unit: 'Cent / kWh',
    category: 'Energiepreis',
    label: 'Wie hoch ist ihr durchschnittlicher Strompreis?',
    description:
      'Ihr durchschnittlicher Gesamtstrompreis (inklusive aller Zulagen) in Cent/kWh. Sollte sich dieser in nächster Zeit stark ändern, geben Sie gerne bereits den erwarteten Wert an.',
    min: 1.0,
    max: 100.0,
    min_err: 'Dieser Wert is leider zu niedrig.',
    max_err: 'Sind Sie sicher? Dieser Wert ist sehr hoch.',
  },
  {
    page: 'has_loadprofile',
    title: 'Lastgang',
    icon: <EnergyProfLogo fill="var(--sidebar-icon-color)" />,
    model: 'transient',
    name: 'has_loadprofile',
    type: 'radio',
    is_required: false,
    category: 'Energieprofil',
    label: 'Haben Sie einen 15-Minütigen Lastgang für Ihren Energiebezug? (Excel oder CSV)',
  },
  {
    page: 'load_profile_upload',
    title: 'Lastgang',
    icon: <EnergyProfLogo fill="var(--sidebar-icon-color)" />,
    model: 'load_profile_upload_whitelabel',
    name: 'load_profile_upload',
    type: 'file',
    is_required: true,
    category: 'Energieprofil',
    label:
      'Bitte laden Sie hier Ihren Netzbezugs-Lastgang des Vorjahres (01.01-31.12.) hoch. Dieser sollte in kW sein und zwei Spalten (Zeitstempel, Verbräuche) enthalten.',
    description:
      'Mit Ihrem Lastgang können wir beispielsweise genaue Abschätzungen zum Eigenverbrauch einer PV-Anlage, den Potentialen von Batteriespeichern uvm. machen',
    max_files: 1, // any number, Infinity by default
    max_size: 50, // in MB, 50 by default
    multiple: false, // false by default
    accept: 'xlsx, csv', // 'csv' by default
    upload_id: 'loadprofile_from_grid',
  },
  {
    page: 'load_profile',
    title: 'Lastgang',
    icon: <EnergyProfLogo fill="var(--sidebar-icon-color)" />,
    model: 'load_profile',
    name: 'daily_profile',
    type: 'custom',
    is_required: false,
    category: 'Energieprofil',
    label: 'Lastprofil über den Tag',
    description:
      'Wie benötigen Sie an einem gewöhnlichen Tag und über das Jahr hinweg Strom? Mit Ihren Angaben können wir Ihren Lastgang abschätzen.',
  },
  {
    page: 'load_profile',
    title: 'Lastgang',
    icon: <EnergyProfLogo fill="var(--sidebar-icon-color)" />,
    model: 'load_profile',
    name: 'monthly_profile',
    type: 'custom',
    is_required: false,
    category: 'Energieprofil',
    label: 'Lastprofil über das jahr',
    description:
      'Betriebsferien, Weihnachtsurlaub, Schwankungen in Ihrem Produktionsbetrieb? Hier wollen wir erfahren, wir viel Sie über das Jahr produzieren. Die Standardeinstellung ist hier Montag-Freitag, also 5 von 7 Tagen (= 71.5% der Zeit). Auch hier ist keine Perfektion gefragt, nur eine grobe Abschätzung. ',
  },
  {
    page: 'is_heat_required',
    title: 'Wärmeversorgung',
    icon: <HeatSupplyLogo fill="var(--sidebar-icon-color)" />,
    model: 'transient',
    name: 'is_heat_required',
    type: 'radio',
    is_required: false,
    category: 'Wärmeversorgung',
    label: 'Wünschen Sie eine Abschätzung zu Ihrem Wärmepumpenpotential?',
  },
  {
    page: 'heat_information',
    title: 'Wärmeversorgung',
    icon: <HeatSupplyLogo fill="var(--sidebar-icon-color)" />,
    model: 'heat_information',
    name: 'heat_information',
    type: 'custom',
    is_required: true,
    category: 'Wärmeversorgung',
  },
  {
    page: 'area_of_building',
    title: 'Beheizte Fläche',
    icon: <BuildingLogo fill="var(--sidebar-icon-color)" />,
    model: 'further_information',
    name: 'area_of_building',
    type: 'integer',
    is_required: true,
    placeholder: '10-1000000',
    unit: 'm²',
    category: 'Gebäudenutzfläche',
    label: 'Wie groß ist die beheizte Nutzfläche Ihres Gebäudes?',
    description:
      'Geben Sie hier eine Abschätzung Ihrer beheizten Nutzfläche an. Dies hilft uns die Erneuerung Ihres Heizungssystems und eine möglicherweise notwendige energetische Sanierung zu analysieren.',
    min: 0.0,
    max: 1000000.0,
    min_err: 'Dieser Wert is leider zu niedrig.',
    max_err: 'Sind Sie sicher? Dieser Wert ist sehr hoch.',
  },
  {
    page: 'wants_charging',
    title: 'Ladepunkte',
    icon: <ChargingStatLogo fill="var(--sidebar-icon-color)" />,
    model: 'transient',
    name: 'wants_charging',
    type: 'radio',
    is_required: false,
    category: 'Ladesäulen',
    label: 'Haben Sie Interesse an Ladesäulen? ',
    description: 'Mit Ladesäulen können Sie nicht nur Geld sparen sondern Teilweise auch dazuverdienen.',
  },
  {
    page: 'has_public_parking',
    title: 'Ladepunkte',
    icon: <ChargingStatLogo fill="var(--sidebar-icon-color)" />,
    model: 'transient',
    name: 'has_public_parking',
    type: 'radio',
    is_required: false,
    category: 'Ladesäulen',
    label: 'Haben Sie einen öffentlich zugänglichen Parkplatz nah an einem Wohngebiet oder einer Schnellstraße? ',
    description:
      'Nah an Wohngebieten oder einer Schnellstraße/Autbahn gibt es oft Bedarf an Ladeinfrastruktur. Indem Sie Ladepunkte öffentlich zugänglich machen können sich die Säulen häufig deutlich schneller amortisieren.',
  },
  {
    page: 'public_charging',
    title: 'Ladepunkte',
    icon: <ChargingStatLogo fill="var(--sidebar-icon-color)" />,
    model: 'further_information',
    name: 'count_normal_public_ev',
    type: 'integer',
    is_required: true,
    placeholder: '0-100',
    category: 'Ladesäulen',
    label: 'Anzahl öfftl. reguläre Ladesäule',
    description:
      'Nah an Wohngebieten können reguläre (bis zu 22 kW) öffentliche Ladesäulen sich schnell amortisieren. Zum Beispiel, indem Autos über Nacht geladen werden können. Sie selber können dabei bestimmen, wann genau die Ladesäule auch öffentlich zugängig sein soll. ',
    min: 0.0,
    max: 100.0,
    min_err: 'Dieser Wert is leider zu niedrig.',
    max_err: 'Sind Sie sicher? Dieser Wert ist sehr hoch.',
  },
  {
    page: 'public_charging',
    title: 'Ladepunkte',
    icon: <ChargingStatLogo fill="var(--sidebar-icon-color)" />,
    model: 'further_information',
    name: 'count_fast_public_ev',
    type: 'integer',
    is_required: true,
    placeholder: '0-100',
    category: 'Ladesäulen',
    label: 'Anzahl öfftl. Schnellladesäule',
    description:
      'Nah an Schnellstraßen und Autobahnen können Schnellladesäulen (mit Ladeleistungen über 50 kW) sich schnell amortisieren. Dies liegt daran, dass Sie eine hohe Nachfrage durch Reisende bedienen und Elektrofahrzeuge in kurzer Zeit aufladen können. Sie selber können dabei bestimmen, wann genau die Ladesäule auch öffentlich zugängig sein soll.',
    min: 0.0,
    max: 100.0,
    min_err: 'Dieser Wert is leider zu niedrig.',
    max_err: 'Sind Sie sicher? Dieser Wert ist sehr hoch.',
  },
  {
    page: 'private_charging',
    title: 'Ladepunkte',
    icon: <ChargingStatLogo fill="var(--sidebar-icon-color)" />,
    model: 'further_information',
    name: 'count_normal_ev',
    type: 'integer',
    is_required: true,
    placeholder: '0-100',
    category: 'Ladesäulen',
    label: 'Anzahl reguläre Ladesäule',
    description:
      'Vor allem für Ihre Mitarbeiterinnen und Mitarbeiter und Ihren internen Fuhrpark kann sich die Investition in interne reguläre (bis zu 22 kW) Ladeinfrastruktur lohnen. Als Rechenbeispiel: Bis 2030 wird erwartet, dass ca. 20 % der Autos batterieelektrisch betrieben sind. Bei 100 Autos auf Ihrem Parkplatz wollen also Maximal 20 geladen werden. An einer Ladesäule können maximal 2 Autos gleichzeitig geladen werden. Es werden also maximal 10 Ladesäulen benötigt. Unser Tipp: Eher etwas konservativ starten und nach und nach ausbauen.',
    min: 0.0,
    max: 100.0,
    min_err: 'Dieser Wert is leider zu niedrig.',
    max_err: 'Sind Sie sicher? Dieser Wert ist sehr hoch.',
  },
  {
    page: 'private_charging',
    title: 'Ladepunkte',
    icon: <ChargingStatLogo fill="var(--sidebar-icon-color)" />,
    model: 'further_information',
    name: 'count_fast_ev',
    type: 'integer',
    is_required: true,
    placeholder: '0-100',
    category: 'Ladesäulen',
    label: 'Anzahl Schnellladesäule',
    description:
      'Interne Schnellladesäulen sind vor allem interessant, wenn Sie (größere) Nutzfahrzeuge damit laden wollen. Ein e-LKW kann beispielsweise in 4-8 Stunden geladen werden. Aber auch kleine Transporter die mehrfach am Tag längere Strecken zurücklegen müssen, können ein Grund für eine Investition sein. Leitfrage: Haben oder planen Sie elektrische Transporter oder LKW? Wenn Sie sich noch unsicher sind, geben Sie doch einfach erstmal eine Abschätzung ein. ',
    min: 0.0,
    max: 100.0,
    min_err: 'Dieser Wert is leider zu niedrig.',
    max_err: 'Sind Sie sicher? Dieser Wert ist sehr hoch.',
  },
  {
    page: 'energy_report',
    title: 'Ergebnisse',
    icon: <ReportLogo fill="var(--sidebar-icon-color)" />,
    model: 'energy_report',
  },
  // {
  //     "page": "address_information",
  //     "model": "address_information",
  //     "name": "company_name",
  //     "type": "text",
  //     "is_required": true,
  //     "category": "Unternehmen & Ansprechpartner"  ,
  //     "label": "Unternehmen"
  // },
  // {
  //     "page": "address_information",
  //     "model": "address_information",
  //     "name": "firstname",
  //     "type": "text",
  //     "is_required": true,
  //     "category": "Kontaktdaten",
  //     "label": "Vorname"
  // },
  // {
  //     "page": "address_information",
  //     "model": "address_information",
  //     "name": "lastname",
  //     "type": "text",
  //     "is_required": true,
  //     "category": "Kontaktdaten",
  //     "label": "Nachname"
  // },
  // {
  //     "page": "address_information",
  //     "model": "address_information",
  //     "name": "telephone",
  //     "type": "tel",
  //     "is_required": true,
  //     "category": "Kontaktdaten",
  //     "label": "Telefon"
  // },
  // {
  //     "page": "address_information",
  //     "model": "address_information",
  //     "name": "notes",
  //     "type": "text",
  //     "is_required": false,
  //     "category": "Kontaktdaten",
  //     "label": "Möchten Sie uns noch etwas mitteilen?"
  // }
];
